/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

type Props = {
  color?: string;
};

const styles = {
  dot: (_: Theme, color?: string) => css`
    padding: 0 var(--cds-spacing-100);
    color: ${color ?? 'inherit'};
  `,
};

const DottedSeparator = ({ color }: Props) => {
  const theme = useTheme();
  return (
    <span aria-hidden css={styles.dot(theme, color)}>
      &#x2022;
    </span>
  );
};

export default DottedSeparator;
